import React from 'react';
import { Stack, Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { useMemo } from 'react';

import imglogo from '../../assets/images/multiples/mplan_reduz.png';

function Copyright() {
  const img = imglogo;
  const isLogoTemp = useMemo(() => img, []);
  const isLogo = <Box component="img" src={`${isLogoTemp}`} sx={{ mr: -0.5, mt: 0.5 }} />;
  const logo = isLogo;

  return (
    <Typography component={'span'} variant="body2" color="text.secondary" align="left">
      <Stack>
        <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
          {logo} Mplan Sistemas © {new Date().getFullYear()} - Todos os direitos reservados
        </Typography>
      </Stack>
    </Typography>
  );
}

function CopyrightMobile() {
  const isLogoTemp = useMemo(() => imglogo, []);
  const year = new Date().getFullYear();

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        py: 1,
        px: 0,
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '6px',
          color: 'text.primary',
          fontSize: '11px',
          lineHeight: 1.2
        }}>
        <Box
          component="img"
          src={isLogoTemp}
          alt=""
          sx={{ width: 24, height: 'auto', flexShrink: 0, verticalAlign: 'middle' }}
        />
        <Box
          component="span"
          sx={{
            minWidth: '220px',
            maxWidth: '100%',
            whiteSpace: 'normal',
            wordBreak: 'normal',
            overflowWrap: 'break-word',
            textAlign: 'center'
          }}>
          Mplan Sistemas © {year} - Todos os direitos reservados
        </Box>
      </Box>
    </Box>
  );
}

export default function Footer() {
  const theme = useTheme();
  const isNarrow = useMediaQuery(theme.breakpoints.down('sm'));

  return <>{isMobile || isNarrow ? <CopyrightMobile /> : <Copyright />}</>;
}
